import React, { Children } from 'react';
import { DollarSign, X } from 'lucide-react';
import { motion } from 'framer-motion';
interface PaymentConfirmedModalProps {
  onNext: () => void;
  onClose: () => void;
}
export function PaymentConfirmedModal({
  onNext,
  onClose
}: PaymentConfirmedModalProps) {
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    show: {
      opacity: 1,
      transition: {
        staggerChildren: 0.08,
        delayChildren: 0.25
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 10
    },
    show: {
      opacity: 1,
      y: 0,
      transition: {
        type: 'spring',
        stiffness: 300,
        damping: 24
      }
    }
  };
  return <div className="absolute inset-0 z-40 flex items-end justify-center" data-id="element-85">
      {/* Backdrop */}
      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} transition={{
      duration: 0.2
    }} onClick={onClose} className="absolute inset-0 bg-black/40" aria-hidden="true" data-id="element-86" />

      {/* Sheet */}
      <motion.div role="dialog" aria-modal="true" aria-label="Payment confirmed" initial={{
      y: '100%'
    }} animate={{
      y: 0
    }} exit={{
      y: '100%'
    }} transition={{
      type: 'spring',
      stiffness: 320,
      damping: 32
    }} className="relative w-full bg-white rounded-t-3xl px-6 pt-8 pb-10 shadow-2xl" data-id="element-87">
        <button onClick={onClose} aria-label="Close" className="absolute top-4 right-4 p-1.5 rounded-full text-gray-400 hover:bg-gray-100 hover:text-gray-700 transition-colors" data-id="element-88">
          <X className="w-5 h-5" data-id="element-89" />
        </button>

        {/* Success Icon */}
        <div className="relative w-24 h-24 mx-auto mb-6" data-id="element-90">
          <motion.div initial={{
          scale: 0.5,
          opacity: 0
        }} animate={{
          scale: 1,
          opacity: 1
        }} transition={{
          type: 'spring',
          stiffness: 260,
          damping: 20,
          delay: 0.1
        }} className="relative z-10 w-24 h-24 bg-[#0F4C3A] rounded-full flex items-center justify-center shadow-lg" data-id="element-91">
            <DollarSign className="w-12 h-12 text-white" strokeWidth={2.5} data-id="element-92" />
          </motion.div>

          <motion.div initial={{
          scale: 0.8,
          opacity: 0.5
        }} animate={{
          scale: 1.4,
          opacity: 0
        }} transition={{
          duration: 1.6,
          repeat: Infinity,
          ease: 'easeOut',
          delay: 0.6
        }} className="absolute inset-0 bg-[#0F4C3A] rounded-full z-0" data-id="element-93" />

          <motion.div initial={{
          scale: 0,
          opacity: 0
        }} animate={{
          scale: 1,
          opacity: 1
        }} transition={{
          type: 'spring',
          stiffness: 400,
          damping: 15,
          delay: 0.45
        }} className="absolute -top-1 -right-1 w-8 h-8 bg-[#0F4C3A] rounded-full flex items-center justify-center border-2 border-white z-20 shadow-sm" data-id="element-94">
            <svg className="w-5 h-5 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-95">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" data-id="element-96" />
            </svg>
          </motion.div>
        </div>

        <motion.div variants={containerVariants} initial="hidden" animate="show" className="flex flex-col items-center w-full" data-id="element-97">
          <motion.h2 variants={itemVariants} className="text-2xl font-bold text-gray-900 mb-2" data-id="element-98">
            Payment confirmed
          </motion.h2>
          <motion.p variants={itemVariants} className="text-sm text-gray-600 text-center mb-6 leading-relaxed" data-id="element-99">
            A Confirmation Email Has Been Sent &amp; Saved In{' '}
            <span className="font-semibold text-gray-900" data-id="element-100">My Documents</span>
          </motion.p>

          <motion.button variants={itemVariants} whileHover={{
          scale: 1.02
        }} whileTap={{
          scale: 0.98
        }} className="text-[#0F4C3A] font-semibold text-sm underline-offset-4 hover:underline py-2 px-4 rounded-lg hover:bg-[#0F4C3A]/5 transition-colors mb-6" data-id="element-101">
            View &amp; Download Receipt
          </motion.button>

          <motion.button variants={itemVariants} whileTap={{
          scale: 0.97
        }} onClick={onNext} className="w-full bg-[#0F4C3A] text-white py-4 rounded-xl font-semibold text-lg hover:bg-[#134E3A] transition-colors shadow-md" data-id="element-102">
            Next
          </motion.button>
        </motion.div>
      </motion.div>
    </div>;
}